// Modo "módulo único": un usuario puede quedar encerrado en UN módulo (entra directo y no navega a otros).
// Las claves deben coincidir con MODULOS_UNICOS_VALIDOS del backend (config.py).
export const MODULOS_UNICOS = [
  { key: "restaurante", label: "Restaurante", path: "/sistema/restaurante" },
  { key: "clinica", label: "Clínica / Fisioterapia", path: "/sistema/clinica" },
  { key: "hoteleria", label: "Hotelería", path: "/sistema/hoteleria" },
  { key: "produccion", label: "Producción (cocina / KDS)", path: "/sistema/produccion" },
  { key: "pdv", label: "Punto de venta (PDV)", path: "/sistema/pdv" },
  { key: "lectura_bombas", label: "Lectura de bombas", path: "/sistema/lectura-bombas" },
  { key: "recetario", label: "Recetario agronómico", path: "/sistema/recetario" },
  { key: "bascula", label: "Báscula", path: "/sistema/bascula" },
  { key: "transporte", label: "Transporte", path: "/sistema/transporte" },
];

export const rutaModuloUnico = (key) => MODULOS_UNICOS.find(m => m.key === key)?.path || null;
